<list-view [liste]="listePerimetres" *ngIf="listePerimetres"></list-view>